import React, {Fragment, useEffect, useState} from "react";
import {Button, Col, Form, Row, Table} from "react-bootstrap";
import {Election} from "../Election";
import {DistrictInfo, Voter} from "./Voter";
import {District} from "../District";
import axios, {AxiosResponse} from "axios";
import {getMessage} from "../util";
import {ObjectMap} from "../ObjectMap";

export type FoundProps = {
    messages: null | ObjectMap<string>
    election: Election
    voter: Voter
    volver: () => any
}

const Found = (props: FoundProps) => {
    const authentication = props.election.configuration.identification_field.split("+")[0];
    const factor: number = props.election.configuration.advanced_config.factor;

    const [districts, setDistricts] = useState<District[]>([]);
    const [district, setDistrict] = useState<String>(props.voter.district.district_id);

    const selectDistrict = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setDistrict(event.target.value);
    }

    useEffect(() => {
        (async () => {
            try {
                const districts: AxiosResponse<District[]> = await axios({
                    method: "get",
                    url: process.env.REACT_APP_API_URL + "/election/" + props.election._id + "/districts"
                });
                setDistricts(districts.data)
            } catch (error) {
                ;
            }
        })()
    }, [props.election._id]);

    return (
        <Fragment>
            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>

                    <Table striped bordered hover>

                        <tbody>
                        <tr>
                            <th>{authentication === 'run' ? getMessage('id_run', props.messages) : getMessage('id', props.messages)}</th>
                            <td>{props.voter.identity}</td>
                        </tr>
                        <tr>
                            <th>{getMessage('name', props.messages)}</th>
                            <td>{props.voter.data.name}</td>
                        </tr>

                        {districts.length > 1 &&
                        (props.election.configuration.advanced_config.can_choose_ballotbox ? (
                                (props.voter.restricted_districts_to ? (
                                        (props.voter.restricted_districts_to.length > 1) ? (
                                            <tr>
                                                <th>{getMessage('district', props.messages)}</th>
                                                <td><Form.Select onChange={selectDistrict}>
                                                    {props.voter.restricted_districts_to.map(d => (
                                                        <option key={d.district_id}
                                                                value={d.district_id}>{d.district}</option>
                                                    ))}
                                                </Form.Select></td>
                                            </tr>) : (
                                            <tr>
                                                <th>{getMessage('district', props.messages)}</th>
                                                <td>{props.voter.district.district}</td>

                                            </tr>
                                        )
                                    ) : (
                                        <tr>
                                            <th>{getMessage('district', props.messages)}</th>
                                            <td><Form.Select onChange={selectDistrict}>
                                                {districts.map(d => (
                                                    <option key={d._id} value={d._id}>{d.name}</option>
                                                ))}
                                            </Form.Select></td>
                                        </tr>

                                    )
                                )
                            ) : (
                                <tr>
                                    <th>Provincia</th>
                                    <td>{props.voter.district.district.split("-")[0]}</td>
                                </tr>
                            )
                        )}
                        {props.election.configuration.advanced_config.weighted && (
                            <tr>
                                <th>{getMessage('weigth', props.messages)}</th>
                                <td>{props.voter.weight / factor}</td>
                            </tr>
                        )}

                        <tr>
                            <th>Categoría</th>
                            <td>{props.voter.district.district.split("-")[1]}</td>
                        </tr>

                        </tbody>
                    </Table>
                </Col>
            </Row>

            {(props.election.state === 'open' && props.election.in_production) && (
                <Row className={"justify-content-center"}>
                    <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>

                        <Button className="EvColorBlue text-white m-1"
                                href={props.election.configuration.encrypter_url.replace('%s', props.election._id) + '?district=' + district}
                                variant="primary">{getMessage('vote_button', props.messages)}</Button>
                    </Col>
                </Row>
            )}


            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>

                    <Button className="EvColorGrisLight m-1" onClick={props.volver}
                            variant="light">{getMessage('ask_again', props.messages)}</Button>
                </Col>
            </Row>
        </Fragment>);
}

export default Found;
